export const foo = (data?: any) => {};

export const utils = {
  // foo,
};
